import axios from 'axios';

const captchaApi = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api',
  timeout: 15000,
});

captchaApi.interceptors.response.use(
  (response) => {
    const body = response.data;
    if (body && body.code === 200) {
      return body.data;
    }
    return Promise.reject(new Error(body?.message || '验证码请求失败'));
  },
  (error) => {
    const body = error.response?.data;
    const msg = body?.message || body?.error || error.message || '验证码请求失败';
    return Promise.reject(new Error(msg));
  }
);

export const captchaAPI = {
  getChallenge: (scene) => captchaApi.get('/auth/captcha/challenge', { params: { scene } }),
  verify: (payload) => captchaApi.post('/auth/captcha/verify', payload),
};

export default captchaAPI;
